export default __webpack_public_path__ + "media/images/front/about/hero_lg-dffa4c2facc4a9e4a23f7da5dd87ce86.jpg";